import { render, staticRenderFns } from "./userSelectFrom.vue?vue&type=template&id=5cbc1c30&scoped=true"
import script from "./userSelectFrom.vue?vue&type=script&lang=js"
export * from "./userSelectFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc1c30",
  null
  
)

export default component.exports